import {ForYouFloorChoiceType} from "../types/ForYouFloorChoiceType";

export const getFloorString = (floors: string[]) => {
    if (!floors || (floors?.length && floors.length === 0)) {
        return "";
    }

    return floors.map((floor) => getFloorName(parseInt(floor))).join(", ");
};

const getFloorName = (quarters: ForYouFloorChoiceType) => {
    switch (quarters) {
        case ForYouFloorChoiceType.GROUND:
            return "Parter";
        case ForYouFloorChoiceType.LOW:
            return "Niskie piętra (1-4)";
        case ForYouFloorChoiceType.HIGH:
            return "Wysokie piętra (5+)";
        case ForYouFloorChoiceType.TOP:
            return "Ostatnie piętro";
        default:
            return "";
    }
};
import {ForYouFloorChoiceType} from "../types/ForYouFloorChoiceType";

export const getFloorString = (floors: string[]) => {
    if (!floors || (floors?.length && floors.length === 0)) {
        return "";
    }

    return floors.map((floor) => getFloorName(parseInt(floor))).join(", ");
};

const getFloorName = (quarters: ForYouFloorChoiceType) => {
    switch (quarters) {
        case ForYouFloorChoiceType.GROUND:
            return "Parter";
        case ForYouFloorChoiceType.LOW:
            return "Niskie piętra (1-4)";
        case ForYouFloorChoiceType.HIGH:
            return "Wysokie piętra (5+)";
        case ForYouFloorChoiceType.TOP:
            return "Ostatnie piętro";
        default:
            return "";
    }
};
